/**
 * The amount of time in milliseconds that a user can hover over a suggestion before we start speculating
 */ export var LISP_SUGGESTION_HOVER_SPECULATION_SHORT_THRESHOLD = 'LISP_SUGGESTION_HOVER_SPECULATION_SHORT_THRESHOLD';
